import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form';
import InlineHelpText from '../../shared/InlineHelpText';
import { FormattedMessage } from 'react-intl';
import {
  firstNameText,
  lastNameText,
  middleNameText,
  noStatusText,
  notesText,

} from '../../shared/SharedInternationalizations';
import HelpIcon from '../../shared/HelpIcon';
import AccessControl from '../../../AccessControl';
import permissions from '../../../permissionsList';
import { Condition } from '../../shared/Condition';

export function UnconnectedUserGeneralInfoForm(props) {
  const userStatuses = props.userStatuses;
  const { values,} = props;
  // const {
  //   // id,
  //   // is_active,
  //   units,
  // } = user;
 

  /**
   * 
   * @returns {object}
   */

  


  const [showUserStatusHelpText, setShowUserStatusHelpText] = useState(false);
  const userStatusHelpTextRef = useRef();
  function toggleUserStatusHelpText(value) {
    setShowUserStatusHelpText(value);
  }
  const userStatusHelpText = (
    <FormattedMessage
      id="userContactForm.userStatusHelpText"
      defaultMessage="This is the user's status."
      description="Help text."
    />
  );

  const [showNotesHelpText, setShowNotesHelpText] = useState(false);
  const notesHelpTextRef = useRef();
  function toggleNotesHelpText(value) {
    setShowNotesHelpText(value);
  }
  const notesHelpText = (
    <FormattedMessage
      id="userContactForm.notesHelpText"
      defaultMessage="This is a place to record notes about the user."
      description="Help text."
    />
  );

  const [
    showUserLogIntoSaraHelpText,
    setShowUserLogIntoSaraHelpText,
  ] = useState(false);
  const userLogIntoSaraHelpTextRef = useRef();
  function toggleShowUserLogIntoSaraHelpText(value) {
    setShowUserLogIntoSaraHelpText(value);
  }
  const userLogIntoSaraHelpText = (
    <FormattedMessage
      id="userGeneralInfoForm.userLogIntoSaraHelpText"
      defaultMessage="This user will need to log into SARA and use the SARA interface."
      description="Help text."
    />
  );
  const [showUserCheckInHelpText, setShowUserCheckInHelpText] = useState(false);
  const userCheckInHelpTextRef = useRef();
  function toggleShowUserCheckInHelpText(value) {
    setShowUserCheckInHelpText(value);
  }
  const userCheckInHelpText = (
    <FormattedMessage
      id="userGeneralInfoForm.userCheckInHelpText"
      defaultMessage="This user will need to check in to SARA and the user's status and check-in status will be tracked."
      description="Help text."
    />
  );
  const [showUserNameHelpText, setShowUserNameHelpText] = useState(false);
  const userNameHelpTextRef = useRef();
  function toggleUserNameHelpText(value) {
    setShowUserNameHelpText(value);
  }
  const userNameHelpText = (
    <FormattedMessage
      id="userGeneralInfoForm.userNameHelpText"
      defaultMessage="The username for this user. Each username must be unique."
      description="Help text."
    />
  );
  const [showPasswordHelpText, setShowPasswordHelpText] = useState(false);
  const passwordHelpTextRef = useRef();
  function togglePasswordHelpText(value) {
    setShowPasswordHelpText(value);
  }
  const passwordHelpText = (
    <FormattedMessage
      id="userGeneralInfoForm.passwordHelpText"
      defaultMessage="The password for this user is already set. If you would like to update the user's password, please use the 'Update Password' link on the user display page or in the quick actions menu on the user list page."
      description="Help text."
    />
  );

  const [showTitleHelpText, setShowTitleHelpText] = useState(false);
  const titleHelpTextRef = useRef();
  function toggleTitleHelpText(value) {
    setShowTitleHelpText(value);
  }
  const titleHelpText = (
    <FormattedMessage
      id="userGeneralInfoForm.titleHelpText"
      defaultMessage="The user's title such as 'Mr', 'Ms','Dr', etc."
      description="Help text."
    />
  );
  const [showPreferredNameHelpText, setShowPreferredNameHelpText] = useState(
    false
  );
  const preferredNameHelpTextRef = useRef();
  function togglePreferredNameHelpText(value) {
    setShowPreferredNameHelpText(value);
  }
  const preferredNameHelpText = (
    <FormattedMessage
      id="userGeneralInfoForm.preferredNameHelpText"
      defaultMessage="The user's preferred name such as Steve instead of Stephen."
      description="Help text."
    />
  );
  const [showSuffixHelpText, setShowSuffixHelpText] = useState(false);
  const suffixHelpTextRef = useRef();
  function toggleSuffixHelpText(value) {
    setShowSuffixHelpText(value);
  }
  const suffixHelpText = (
    <FormattedMessage
      id="userGeneralInfoForm.suffixHelpText"
      defaultMessage="The user's suffix such as 'Jr', 'Ph.D.', etc."
      description="Help text."
    />
  );

  const [showPhotoHelpText, setShowPhotoHelpText] = useState(false);
  const photoHelpTextRef = useRef();
  function togglePhotoHelpText(value) {
    setShowPhotoHelpText(value);
  }
  const photoHelpText = (
    <FormattedMessage
      id="userGeneralInfoForm.photoHelpText"
      defaultMessage="This will show an interface to add a profile picture for this user after you have completed creating the user."
      description="Help text."
    />
  );

  const passwordRequired = (value) =>
    value ? undefined : 'A password is required';
  const firstNameRequired = (value) =>
    value ? undefined : 'A first name is required';
  const lastNameRequired = (value) =>
    value ? undefined : 'A last name is required';
  const userNameRequired = (value) =>
    value ? undefined : 'A user name is required';

  // I tried to use internationalized text for this message but when I did, it showed in the
  // browser as "item" so I left it as an untranslated string.

  function passwordDisplay() {
    if (values && !values.hasProfile) {
      return (
        <Field
          className="form-item__field"
          name="password"
          component="input"
          type="password"
          validate={passwordRequired}>
          {({ input, meta }) => (
            <React.Fragment>
              <input
                {...input}
                type="password"
                className={
                  meta.error && meta.touched
                    ? 'form-item__field form-item__field--error'
                    : 'form-item__field'
                }
              />
              {meta.error && meta.touched && (
                <span className="form-item__field-message--required text-small">
                  {meta.error}
                </span>
              )}
            </React.Fragment>
          )}
        </Field>
      );
    } else {
      return (
        <input
          className="form-item__field"
          type="text"
          disabled
          value="••••••••••••••••••••"
        />
      );
    }
  }


  function statusDisplay() {
    const statusDisplay = userStatuses.map((status, index) => {
      return (
        <option value={status.id} key={index}>
          {status.description}
        </option>
      );
    });

    return statusDisplay;
  }




  return (
    <React.Fragment>
      <div className="content-display__container">
        <AccessControl
          data-test="access-control"
          feature={permissions.static.users.addSaraPreferences}>
          <React.Fragment>
            <div className="content-display__column content-display__column--2-3">
              <div className="content-display__item-container">
                <div className="item-container__main-container">
                  <Field
                    className="visually-hidden"
                    name="isStaff"
                    component="input"
                    type="checkbox"
                    id="userAddEditisStaff"
                    data-test="is-staff"
                    disabled={values.usesCheckin || values.hasProfile}
                    
                  />     
                  <label
                    htmlFor="userAddEditisStaff"
                    className={
                      values.usesCheckin || values.hasProfile
                        ? 'text-large text-dimmed text-light form-item__field-toggle'
                        : 'text-large text-light text-deep-blue form-item__field-toggle'
                    }>
                    <FormattedMessage
                      id="userGeneralInfoForm.userLogInSara"
                      defaultMessage="This user will log into SARA"
                      description="The user's title such as 'Mr', 'Ms','Dr', etc "
                    />
                  </label>     
                </div>
                <div className="item-container__info-container">
                  <HelpIcon
                    onClick={() =>
                      userLogIntoSaraHelpTextRef.current.toggleHelpText()
                    }
                    toggled={showUserLogIntoSaraHelpText}
                    styles="margin-left-5"
                  />
                </div>
              </div>
            </div>
            <div className="content-display__column content-display__column--1-3" />
            <InlineHelpText
              ref={userLogIntoSaraHelpTextRef}
              toggleFunction={toggleShowUserLogIntoSaraHelpText}
              message={userLogIntoSaraHelpText}
            />
          </React.Fragment>
        </AccessControl>

        <AccessControl
          data-test="access-control"
          feature={permissions.static.users.addUserCheckinProfile}>
          <React.Fragment>
            <div className="content-display__column content-display__column--2-3">
              <div className="content-display__item-container">
                <div className="item-container__main-container">
                  <Field
                    className="visually-hidden"
                    name="usesCheckin"
                    component="input"
                    type="checkbox"
                    id="usesCheckin"
                    data-test="uses-checkin"
                    disabled={values.isStaff || values.hasProfile}
                  />
                  <label
                    htmlFor="usesCheckin"
                    className={
                      values.isStaff || values.hasProfile
                        ? 'text-large text-dimmed text-light form-item__field-toggle'
                        : 'text-large text-light text-deep-blue form-item__field-toggle'
                    }>
                    <FormattedMessage
                      id="userGeneralInfoForm.userUsesCheckIn"
                      defaultMessage="This user will need to check in to SARA"
                      description="The user's title such as 'Mr', 'Ms','Dr', etc "
                    />
                  </label>
                </div>
                <div className="item-container__info-container">
                  <HelpIcon
                    onClick={() =>
                      userCheckInHelpTextRef.current.toggleHelpText()
                    }
                    toggled={showUserCheckInHelpText}
                    styles="margin-left-5"
                  />
                </div>
              </div>
            </div>
            <div className="content-display__column content-display__column--1-3"></div>
            <InlineHelpText
              ref={userCheckInHelpTextRef}
              toggleFunction={toggleShowUserCheckInHelpText}
              message={userCheckInHelpText}
            />
          </React.Fragment>
        </AccessControl>

        <Condition when="hasPhoto" is={false}>
          <div className="content-display__column content-display__column--2-3">
            <div className="content-display__item-container">
              <div className="item-container__main-container">
                <Field
                  className="visually-hidden"
                  name="addPhoto"
                  component="input"
                  type="checkbox"
                  id="addPhoto"
                  data-test="add-photo"
                />
                <label
                  htmlFor="addPhoto"
                  className={
                    'text-large text-light text-deep-blue form-item__field-toggle'
                  }>
                  <FormattedMessage
                    id="userGeneralInfoForm.photoLabel"
                    defaultMessage="Add a profile picture for this user"
                    description="The city of the unit being created"
                  />
                </label>
              </div>
              <div className="item-container__info-container">
                <HelpIcon
                  onClick={() => photoHelpTextRef.current.toggleHelpText()}
                  toggled={showPhotoHelpText}
                  styles="margin-left-5"
                />
              </div>
            </div>
          </div>
          <div className="content-display__column content-display__column--1-3"></div>
          <InlineHelpText
            ref={photoHelpTextRef}
            toggleFunction={togglePhotoHelpText}
            message={photoHelpText}
          />
        </Condition>
        <div className="content-display__column content-display__column--1-8">
          <div className="content-display__item-container">
            <div className="item-container__main-container">
              <label className="text-large text-light text-deep-blue">
                <FormattedMessage
                  id="userGeneralInfoForm.userTitleLabel"
                  defaultMessage="Title:"
                  description="The user's title such as 'Mr', 'Ms','Dr', etc "
                />
              </label>

              <Field
                className="form-item__field"
                name="title"
                component="input"
                type="text"
              />
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                onClick={() => titleHelpTextRef.current.toggleHelpText()}
                toggled={showTitleHelpText}
                styles="margin-left-5"
              />
            </div>
          </div>
          <InlineHelpText
            ref={titleHelpTextRef}
            toggleFunction={toggleTitleHelpText}
            message={titleHelpText}
          />
        </div>
        <div className="content-display__column content-display__column--1-4">
          <div className="content-display__item-container">
            <div className="item-container__main-container">
              <label className="text-large text-light text-deep-blue form-item__field-message--required">
                {firstNameText}:
              </label>
              <Field
                className="form-item__field"
                name="first_name"
                component="input"
                type="text"
                validate={firstNameRequired}>
                {({ input, meta }) => (
                  <React.Fragment>
                    <input
                      {...input}
                      type="text"
                      className={
                        meta.error && meta.touched
                          ? 'form-item__field form-item__field--error'
                          : 'form-item__field'
                      }
                    />
                    {meta.error && meta.touched && (
                      <span className="form-item__field-message--required text-small">
                        {meta.error}
                      </span>
                    )}
                  </React.Fragment>
                )}
              </Field>
            </div>
          </div>
        </div>
        <div className="content-display__column content-display__column--1-4">
          <div className="content-display__item-container">
            <div className="item-container__main-container">
              <label className="text-large text-light text-deep-blue">
                {middleNameText}:
              </label>
              <Field
                className="form-item__field"
                name="middle_name"
                component="input"
                type="text"
              />
            </div>
          </div>
        </div>
        <div className="content-display__column content-display__column--1-4">
          <div className="content-display__item-container">
            <div className="item-container__main-container">
              <label className="text-large text-light text-deep-blue form-item__field-message--required">
                {lastNameText}:
              </label>
              <Field
                className="form-item__field"
                name="last_name"
                component="input"
                type="text"
                validate={lastNameRequired}>
                {({ input, meta }) => (
                  <React.Fragment>
                    <input
                      {...input}
                      type="text"
                      className={
                        meta.error && meta.touched
                          ? 'form-item__field form-item__field--error'
                          : 'form-item__field'
                      }
                    />
                    {meta.error && meta.touched && (
                      <span className="form-item__field-message--required text-small">
                        {meta.error}
                      </span>
                    )}
                  </React.Fragment>
                )}
              </Field>
            </div>
          </div>
        </div>

        <div className="content-display__column content-display__column--1-3">
          <div className="content-display__item-container">
            <div className="item-container__main-container">
              <label className="text-large text-light text-deep-blue">
                <FormattedMessage
                  id="userGeneralInfoForm.userSuffixTitle"
                  defaultMessage="Suffix:"
                  description="The user's suffix such as 'Jr', 'Ph.D.', etc "
                />
              </label>

              <Field
                className="form-item__field"
                name="suffix"
                component="input"
                type="text"
              />
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                onClick={() => suffixHelpTextRef.current.toggleHelpText()}
                toggled={showSuffixHelpText}
                styles="margin-left-5"
              />
            </div>
          </div>
          <InlineHelpText
            ref={suffixHelpTextRef}
            toggleFunction={toggleSuffixHelpText}
            message={suffixHelpText}
          />
        </div>

        <div className="content-display__column content-display__column--1-3">
          <div className="content-display__item-container">
            <div className="item-container__main-container">
              <label className="text-large text-light text-deep-blue">
                <FormattedMessage
                  id="userGeneralInfoForm.userPreferredNameLabel"
                  defaultMessage="Preferred Name:"
                  description="The user's preferred name such as Rob instead of Robert."
                />
              </label>

              <Field
                className="form-item__field"
                name="preferred_name"
                component="input"
                type="text"
              />
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                onClick={() =>
                  preferredNameHelpTextRef.current.toggleHelpText()
                }
                toggled={showPreferredNameHelpText}
                styles="margin-left-5"
              />
            </div>
          </div>
          <InlineHelpText
            ref={preferredNameHelpTextRef}
            toggleFunction={togglePreferredNameHelpText}
            message={preferredNameHelpText}
          />
        </div>

        <div className="content-display__column content-display__column--1-3">
          <div className="content-display__item-container">
            <div className="item-container__main-container">
              <label className="text-large text-light text-deep-blue">
                <FormattedMessage
                  id="userGeneralInfoForm.dateOfBirthTitle"
                  defaultMessage="Date of Birth:"
                  description="The date of birth of the user"
                />
              </label>
              <Field
                className="form-item__field"
                name="date_of_birth"
                component="input"
                type="date"
              />
            </div>
            <div className="item-container__info-container"></div>
          </div>
        </div>

        <div className="content-display__column content-display__column--1-3">
          <div className="content-display__item-container">
            <div className="item-container__main-container">
              <label className="text-large text-light text-deep-blue">
                <FormattedMessage
                  id="userGeneralInfoForm.genderLabel"
                  defaultMessage="Gender:"
                  description="The city of the unit being created"
                />
              </label>

              <Field
                className="form-item__field"
                name="gender"
                component="select">
                <option value=""></option>
                <FormattedMessage
                  id="userGeneralInfoForm.selectMaleText"
                  defaultMessage="<b>Male</b>"
                  key="male"
                  values={{
                    b: (msg) => <option value="M">{msg}</option>,
                  }}
                />
                <FormattedMessage
                  id="userGeneralInfoForm.selectFemaleText"
                  defaultMessage="<b>Female</b>"
                  key="female"
                  values={{
                    b: (msg) => <option value="F">{msg}</option>,
                  }}
                />
              </Field>
            </div>
          </div>
        </div>
            {/* User Status moved from UserContactForm.js */}
        <div className="content-display__column content-display__column--1-3">
          <div className="content-display__item-container">
            <div className="item-container__main-container">
              <label className="text-large text-light text-deep-blue">
                <FormattedMessage
                  id="userContactForm.stateLabel"
                  defaultMessage="User Status:"
                  description="The state of the unit being created"
                />
              </label>
              <Field
                className="form-item__field"
                name="status"
                component="select">
                {noStatusText}
                {statusDisplay()}
              </Field>
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                onClick={() => userStatusHelpTextRef.current.toggleHelpText()}
                toggled={showUserStatusHelpText}
                styles="margin-left-5"
              />
            </div>
          </div>
          <InlineHelpText
            ref={userStatusHelpTextRef}
            toggleFunction={toggleUserStatusHelpText}
            message={userStatusHelpText}
          />
        </div>
       
        
        <div className="content-display__column content-display__column--3-4"></div>

        <Condition when="isStaff" is={true}>
          <div className="content-display__column content-display__column--1-2">
            <div className="content-display__item-container">
              <div className="item-container__main-container">
                <label className="text-large text-light text-deep-blue form-item__field-message--required">
                  <FormattedMessage
                    id="userGeneralInfoForm.userNameLabel"
                    defaultMessage="Username:"
                    description="The username of the user being created. If the user was automatically created, they have been given a username by the system. This can be updated if necessary."
                  />
                </label>
                <Field
                  className="form-item__field"
                  name="username"
                  component="input"
                  type="text"
                  validate={userNameRequired}>
                  {({ input, meta }) => (
                    <React.Fragment>
                      <input
                        {...input}
                        type="text"
                        className={
                          meta.error && meta.touched
                            ? 'form-item__field form-item__field--error'
                            : 'form-item__field'
                        }
                      />
                      {meta.error && meta.touched && (
                        <span className="form-item__field-message--required text-small">
                          {meta.error}
                        </span>
                      )}
                    </React.Fragment>
                  )}
                </Field>
              </div>
              <div className="item-container__info-container">
                <HelpIcon
                  onClick={() => userNameHelpTextRef.current.toggleHelpText()}
                  toggled={showUserNameHelpText}
                  styles="margin-left-5"
                />
              </div>
            </div>
            <InlineHelpText
              ref={userNameHelpTextRef}
              toggleFunction={toggleUserNameHelpText}
              message={userNameHelpText}
            />
          </div>
          <div className="content-display__column content-display__column--1-2">
            <div className="content-display__item-container">
              <div className="item-container__main-container">
                <label className="text-large text-light text-deep-blue">
                  <FormattedMessage
                    id="userGeneralInfoForm.unitNameLabel"
                    defaultMessage="Password:"
                    description="The username of the user being created"
                  />
                </label>
                {passwordDisplay()}
              </div>
              <div className="item-container__info-container">
                <HelpIcon
                  onClick={() => passwordHelpTextRef.current.toggleHelpText()}
                  toggled={showPasswordHelpText}
                  styles="margin-left-5"
                />
              </div>
              <InlineHelpText
                ref={passwordHelpTextRef}
                toggleFunction={togglePasswordHelpText}
                message={passwordHelpText}
              />
            </div>
          </div>
        </Condition>
        <Condition when="show_panic_buttons" is={false}>
          <div className="content-display__column content-display__column--2-3"></div>
        </Condition>

        <div className="width-100"></div>

          {/* Notes moved from UserContactForm.js */}
        <div className="content-display__column content-display__column--1-2"></div>
        <div className="content-display__column content-display__column">
          <div className="content-display__item-container">
            <div className="item-container__main-container">
              <label className="text-large text-light text-deep-blue">
                {notesText}:
              </label>
              <Field
                className="form-item__field"
                name="notes"
                component="textarea"
              />
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                onClick={() => notesHelpTextRef.current.toggleHelpText()}
                toggled={showNotesHelpText}
                styles="margin-left-5"
              />
            </div>
          </div>
          <InlineHelpText
            ref={notesHelpTextRef}
            toggleFunction={toggleNotesHelpText}
            message={notesHelpText}
          />
        </div>
        <div className="width-100"></div>

      </div>
    </React.Fragment>



  );
}

const mapStateToProps = (state, ownProps) => {
  const userStatuses = Object.values(state.users.userStatuses);
  return {
    userStatuses,
    unitsObj: state.units.units,
  };
};

export default connect(mapStateToProps) (UnconnectedUserGeneralInfoForm);
